module.exports = __webpack_public_path__ + "img/3-Bullion_spec_hero.aed707a0.svg";